export enum HublerDocumentAction {
  DELETE = 'DELETE',
  INITIALIZE = 'INITIALIZE',
  METADATA_UPSERTED = 'METADATA_UPSERTED',
  UPLOAD = 'UPLOAD',
}
